export default __webpack_public_path__ + "static/media/cancel.17825c74.svg";